import { gql } from 'apollo-boost';

export const services = gql`
  query {
    services {
      name
      description
      dbId
      version
    }
  }
`;
